module.exports = __webpack_public_path__ + "static/media/tipo_cuenta.34b2d53f.svg";